import api from "../../repository/repository";

export const makeStripePayment =
  (stripe, elements, stripeAmount, restaurantID, email) => async (dispatch) => {
    try {
      const cardElement = elements.getElement("cardNumber")
      const { token, error } = await stripe.createToken(cardElement);

      if (error) throw new Error(error.message);

      const body = {
        tokenId: token.id,
        restaurantID,
        amount: Number(stripeAmount),
        email,
        currency: "USD",
      };

      const res = await api.post("/payment", body); // ✅ using baseURL

      return res.data;
    } catch (err) {
      throw err;
    }
  };
